import AccountCardEmptyTextAlertModal, {
  ACCOUNT_CARD_EMPTY_TEXT_ALERT_MODAL,
} from './AccountCardEmptyTextAlertModal';

export { ACCOUNT_CARD_EMPTY_TEXT_ALERT_MODAL };

export default AccountCardEmptyTextAlertModal;
